// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RealtorDetails_wrapper__wnOlF","wrapper__title":"RealtorDetails_wrapper__title__30eCj"};